/**
 * local-storage-auth-gateway.js
 * Persists authentication snapshot in localStorage.
 */
const DEFAULT_AUTH_KEY = 'agilepro.auth.v1';
const TOKEN_KEY = 'agilepro_auth_token';

function getStorage(defaultStorage) {
  if (defaultStorage) {
    return defaultStorage;
  }
  if (typeof window !== 'undefined' && window.localStorage) {
    return window.localStorage;
  }
  return null;
}

function createDefaultAuth() {
  return { isLoggedIn: false, name: '', email: '', id: null };
}

export class LocalStorageAuthGateway {
  constructor({ storage = null, key = DEFAULT_AUTH_KEY } = {}) {
    this.storage = getStorage(storage);
    this.key = key;
  }

  load() {
    if (!this.storage) {
      return createDefaultAuth();
    }

    const raw = this.storage.getItem(this.key);
    if (!raw) {
      const defaults = createDefaultAuth();
      this.storage.setItem(this.key, JSON.stringify(defaults));
      return defaults;
    }

    try {
      const parsed = JSON.parse(raw);
      if (typeof parsed === 'object' && parsed !== null) {
        return parsed;
      }
    } catch (error) {
      // Fall through to reset below.
    }

    this.storage.removeItem(this.key);
    return this.load();
  }

  save(patch = {}) {
    const base = this.load();
    const next = { ...base, ...patch };
    if (this.storage) {
      this.storage.setItem(this.key, JSON.stringify(next));
    }
    return next;
  }

  clear() {
    if (this.storage) {
      this.storage.removeItem(this.key);
    }
  }

  getToken() {
    if (!this.storage) {
      return null;
    }
    return this.storage.getItem(TOKEN_KEY);
  }

  setToken(token) {
    if (!this.storage) {
      return;
    }
    if (!token) {
      this.storage.removeItem(TOKEN_KEY);
    } else {
      this.storage.setItem(TOKEN_KEY, token);
    }
  }
}

if (typeof window !== 'undefined') {
  window.AgileProGateways = window.AgileProGateways || {};
  window.AgileProGateways.LocalStorageAuthGateway = LocalStorageAuthGateway;
}
